var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { styled } from '@stitches/react';
import { PaginationItem } from './PagintationItem';
var defaults = {
    delta: 1,
    itemsPerPage: 10,
};
var PaginationElement = styled('div', {});
export var Pagination = function (_a) {
    var as = _a.as, currentPage = _a.currentPage, totalPages = _a.totalPages, itemsPerPage = _a.itemsPerPage, totalItems = _a.totalItems, delta = _a.delta, baseCss = _a.baseCss, itemCss = _a.itemCss, itemComponent = _a.itemComponent, labels = _a.labels, onPageChange = _a.onPageChange, props = __rest(_a, ["as", "currentPage", "totalPages", "itemsPerPage", "totalItems", "delta", "baseCss", "itemCss", "itemComponent", "labels", "onPageChange"]);
    if (!totalPages && totalItems) {
        // Calculate total pages from {totalItems} & {itemsPerPage}
        totalPages = Math.ceil(totalItems / (itemsPerPage || defaults.itemsPerPage));
    }
    else if (!totalPages && !totalItems) {
        totalPages = 0;
    }
    var pages = React.useMemo(function () {
        var left = currentPage - (delta || defaults.delta);
        var right = currentPage + (delta || defaults.delta) + 1;
        var pages = [];
        var pagesWithEllipsis = [];
        for (var page = 1; page <= totalPages; page++) {
            if (page === 1 || page === totalPages || (page >= left && page < right)) {
                pages.push(page);
            }
        }
        var lastIterated;
        for (var _i = 0, pages_1 = pages; _i < pages_1.length; _i++) {
            var page = pages_1[_i];
            if (lastIterated) {
                if (page - lastIterated === 2) {
                    pagesWithEllipsis.push(lastIterated + 1);
                }
                else if (page - lastIterated !== 1) {
                    pagesWithEllipsis.push('...');
                }
            }
            pagesWithEllipsis.push(page);
            lastIterated = page;
        }
        return pagesWithEllipsis;
    }, [currentPage, totalPages, delta]);
    var elementProps = {};
    var Element = as || PaginationElement;
    if (as)
        elementProps = __assign({}, props);
    else
        elementProps = { css: baseCss };
    return (React.createElement(React.Fragment, null, pages.length > 1 ? (React.createElement(Element, __assign({}, elementProps),
        React.createElement(PaginationContext.Provider, { value: { itemComponent: itemComponent, labels: labels, itemCss: itemCss } },
            React.createElement(PaginationItem, { itemType: "first", onClick: function () { return onPageChange(1); }, isDisabled: currentPage === 1 }),
            React.createElement(PaginationItem, { itemType: "previous", onClick: function () { return onPageChange(currentPage - 1); }, isDisabled: currentPage === 1 }),
            pages.map(function (page, index) {
                return page === '...' ? (React.createElement(PaginationItem, { itemType: "ellipsis", key: index })) : (React.createElement(PaginationItem, { key: index, page: page, itemType: "page", isActive: page === currentPage, onClick: function () { return onPageChange(page); } }, page));
            }),
            React.createElement(PaginationItem, { itemType: "next", onClick: function () { return onPageChange(currentPage + 1); }, isDisabled: currentPage === totalPages }),
            React.createElement(PaginationItem, { itemType: "last", onClick: function () { return onPageChange(totalPages); }, isDisabled: currentPage === totalPages })))) : null));
};
Pagination.defaultProps = {
    delta: defaults.delta,
    itemsPerPage: defaults.itemsPerPage,
};
export var PaginationContext = React.createContext({});
